import { createStore } from 'effector'
import { getStoriesInfoFx, uploadStoriesFx } from './effects'
import { StoriesInfo } from '../types'

export const $uploadStories = createStore(null).on(uploadStoriesFx.doneData, (_, data) => data.content)
export const $storiesInfo = createStore<StoriesInfo | null>(null).on(getStoriesInfoFx.doneData, (_, data) => data)
